import { Service } from '../Service'
import { ModelStock } from './models'
import { setToModel } from '@/utils/objects'
import { stockStatusFilter } from '@/utils/shared'
import { toDate, toPriceCurrency } from '@/utils/filters'

const ENDPOINTS = {
  GET: 'Stocks/Get',
  GET_DYNAMIC: 'Stocks/GetAllDynamic',
  POST: 'Stocks/Create',
  PATCH: 'Stocks/Patch',
  PUT: 'Stocks/Put',
  DELETE: 'Stocks/Delete'
}

class ModuleServiceStocks extends Service {
  async createDuplicate ({ originStockID, data }) {
    const _data = setToModel(new ModelStock(), data, {
      entryDate: new Date(),
      statusID: 1,
      ppwPath: null,
      ppwAttached: null,
      photoAttached: null,

      weightDimensions: null,
      supplierPaymentDate: null,
      tagInfoCompanyID: null,
      traceabilityCompanyID: null,
      tagDate: null,
      conditionID: null,
      releaseID: null,
      stockLocationID: null,
      warehouseLocationID: null,
      externalLocationCompanyID: null,

      statusInd: null,
      statusDate: null,
      nonIncident: false
    })
    return ServiceStocks.post({ ..._data, originalUnitStockID: originStockID })
  }
  async getStocksWithTheSamePart ({ id }) {
    const { data } = await this.get(id)
    const { partID, statusID } = data

    if (!partID) {
      return []
    }

    const filter = [
      `partID==${partID}`,
      `id!=${id}`,
      stockStatusFilter({ value: statusID })
    ].join('&&')

    const resultStocks = await this.getAllDynamic({ select: 'id, partID', filter: filter })

    return resultStocks.data.value || []
  }
  async updateStockSale () {
    this.getAllDynamic({ })
  }
  async updateStockExch () {
  }

  makeStockTextInfo (row) {
    const EMPTY = '--'

    const set = (value) => {
      if (!value) return EMPTY
      return value
    }

    const strings = [
      `- P/N: ${set(row.partNumber)}`,
      `- COND.: ${set(row.conditionTitle)}`,
      `- CERT.: ${set(row.releaseTitle)} By ${set(row.tagBy)}`,
      `- CERT. DATE: ${row.tagDate ? toDate(row.tagDate) : EMPTY}`,
      `- QTY: ${set(row.qty)}`,
      `- UNIT PRICE: ${toPriceCurrency(row.sellPrice, row.currencyTitle)}`,
      `- DELIVERY: ${set(row.stockLocationTitle)}`
    ]

    const res = strings.join('\n')

    return res
  }
}

export const ServiceStocks = new ModuleServiceStocks({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})

export * from './models'
